<template>
  <div>
    
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

const CHAT_START_KEY = 'chat_start_time'

onMounted(() => {

    const now = Date.now()
    const startTime = sessionStorage.getItem(CHAT_START_KEY)
    const recommyDelay = window.appSettings.RecommyDelay ? parseInt(window.appSettings.RecommyDelay) : 30000

    const widgetId = window.appSettings.RecommyWidgetId;

    if (!startTime) {
        sessionStorage.setItem(CHAT_START_KEY, now.toString())
        setTimeout(showChat, recommyDelay)
    } else {
        showChat();
    }

    function showChat() {
        addRecommyStyleFix()
        checkChatVisibility()
    }

    function addRecommyStyleFix() {
        // Prevent adding multiple times
        if (document.getElementById('recommy-style-fix')) return

        const style = document.createElement('style')
        style.id = 'recommy-style-fix'

        style.innerHTML = `
        [id*="recommy"], [class*="recommy"] {
            --fa-font-family: initial;
        }

        [id*="recommy"] .fa-star::before,
        [class*="recommy"] .fa-star::before {
            content: initial !important;
            font-family: initial !important;
        }
        `

        document.head.appendChild(style)
    }

    function checkChatVisibility() {
        if (!window.RecommyFeedbackWidget) {
            const script = document.createElement('script')
            script.type = 'text/javascript'
            script.text = `
                !function (w, d, t, s) {
                if (w.RecommyFeedbackWidget) return;
                var n = w.RecommyFeedbackWidget = function () {
                    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
                };
                n.push = n;
                n.queue = [];
                var k = d.createElement(t);
                k.src = s;
                var b = d.getElementsByTagName(t)[0];
                b.parentNode.insertBefore(k, b);
                }(window, document, 'script', 'https://app.recommy.com/Services/Widgets/v3/Widget.ashx?js=1&widget=` + widgetId + `&' + new Date().getMilliseconds());
            `
            document.head.appendChild(script)
        }
    }
})
</script>